export default "__VITE_ASSET__Cp6lYE8d__$_?url__"